/* eslint-disable react-refresh/only-export-components */
import type { Person } from '@/store/people/types';
import type { Milestone } from '@/store/milestones/types';
import { createContext, useContext, useState, type ReactNode } from 'react';
import { MilestoneModal } from './modal';

export interface MilestoneModalState {
  open: boolean;
  setOpen: (value: boolean) => void;
  currentMilestone: Milestone | null;
  setCurrentMilestone: (value: Milestone | null) => void;
  currentPerson: Person | null;
  setCurrentPerson: (value: Person | null) => void;
  setOnCreate: (callback: MilestoneCallback | null) => void;
  setOnUpdate: (callback: MilestoneCallback | null) => void;
}

const MilestoneModalContext = createContext({} as MilestoneModalState);

type MilestoneCallback = { callback: (item: Milestone) => void };

export function MilestoneModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [currentMilestone, setCurrentMilestone] = useState<Milestone | null>(
    null,
  );
  const [currentPerson, setCurrentPerson] = useState<Person | null>(null);
  const [onCreate, setOnCreate] = useState<MilestoneCallback | null>(null);
  const [onUpdate, setOnUpdate] = useState<MilestoneCallback | null>(null);
  const state: MilestoneModalState = {
    open,
    setOpen,
    currentMilestone,
    setCurrentMilestone,
    currentPerson,
    setCurrentPerson,
    setOnCreate,
    setOnUpdate,
  };

  return (
    <MilestoneModalContext.Provider value={state}>
      <>
        <MilestoneModal
          isOpen={open}
          onOpenChange={setOpen}
          target={currentPerson}
          milestone={currentMilestone}
          onCreate={onCreate?.callback || undefined}
          onUpdate={onUpdate?.callback || undefined}
        />
        {children}
      </>
    </MilestoneModalContext.Provider>
  );
}

export function useMilestoneModal() {
  return useContext(MilestoneModalContext);
}
